<template>
<div class="gocat-wrap" ref="goCatContainer">
    <div class="go-cat">
        <div class="go-header">
            <Header></Header>
        </div>
        <div class="go-content">
            <div class="content-item" v-for="(item,index) in GOList" :key="index">
                <div class="content">
                    <div v-if="!item.action_status" class="content-img" @click="$router.push(`/enquiry/${item.id}`)">
                        <img :src="item.photo" alt="">
                    </div>
                    <div v-if="item.action_status" class="content-img">
                        <img :src="item.photo" alt="">
                    </div>
                    <div class="content-info">
                        <div class="wrap info">
                            <div class="info-left">
                                <div class="title">
                                    <span>{{item.name}}</span>
                                </div>
                                <div class="count">
                                    <span>本期已报名</span>
                                    <span class="num">{{item.number}}人</span>
                                </div>

                            </div>
                            <div>
                                <el-button v-if="!item.action_status" type="danger" @click="$router.push(`/enquiry/${item.id}`)">活动详情</el-button>
                                <el-button type="danger" v-if="item.action_status" @click="overdue">活动已过期</el-button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <Footer class="app-footer"></Footer>
    </div>
</div>
</template>

<script>
import vuescroll from 'vuescroll';
import BScroll from 'better-scroll'
import Footer from '@/components/Footer/Footer';
import Header from '@/components/Header/Header';

export default {
    name: 'GoCatPreferential',
    components: {
        vuescroll,
        Header,
        Footer,
    },
    data() {
        return {
            value: '',
            GOList: [],
            newGoList: [],
            page: 1,
            pageSize: 8,
            mes: '已经全部加载完成。。。',

        }

    },
    methods: {
        async getActionList(data) {
            const result = await this.$http.goCatPreferential.getActionList(data);
            if (result.code === 200) {
                this.GOList.push(...result.data);

            } else {
                // this.$message({
                //   message: '暂无数据。。。',
                //   type: 'error',
                //   center: true
                // })
                return
            }
        },
        initScroll() {
            this.scroll = new BScroll(this.$refs.goCatContainer, {
                scrollY: true,
                click: true,
                probeType: 3,
                pullUpLoad: {
                    threshold: -50, // 在上拉到超过底部 20px 时，触发 pullingUp 事件
                    stop: 20
                },
            })
            this.scroll.on('pullingUp', async (params) => {
                const {
                    page,
                    pageSize
                } = this
                this.page = page + 1;
                await this.getActionList({
                    page: this.page,
                    pageSize
                })
                this.$nextTick(() => {
                    this.scroll.refresh()
                    this.scroll.finishPullUp()
                })
            })
        },
        overdue() {
            this.$message({
                message: '当前活动已经过期~~',
                type: 'error',
                center: true,
                offset: 100
            })
        }

    },
    created() {
        this.getActionList({
            page: this.page
        });
        setTimeout(() => {
            this.$nextTick(() => {
                this.initScroll()
            })
        }, 500)

    },
    mounted() {},

}
</script>

<style lang="less">
.gocat-wrap {
    height: 100vh;
    overflow: hidden;
    .go-cat {
        width: 100%;

        .go-header {
            width: 100%;
            margin-bottom: 20px;

            .go-hot {
                height: 50px;
                background-color: #fafafa;
                padding-left: 30px;
                line-height: 50px;
                font-size: 20px;
                color: #c1452d;
                font-weight: 700;
                margin-bottom: 20px;
            }

            .search {
                height: 60px;
                display: flex;
                justify-content: space-between;
                padding: 0 5px;

                .el-input {

                    input {
                        height: 60px;
                        width: 100%;
                    }
                }

                button {
                    width: 30%;
                }
            }
        }

        .go-content {
            .content-item {
                padding: 0 5px;

                .title {
                    height: 40px;

                    span {
                        font-size: 28px;
                        line-height: 40px;
                        font-weight: 700;
                    }
                }

                .content {
                    .content-img {
                        height: 300px;
                        height: 400px;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                    }
                }

                .content-info {
                   margin-top: 20px;
                    margin-bottom: 20px;
                    padding: 0 20px;

                    .info {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .info-left{
                            width: 70vw;
                            white-space:nowrap;
                            overflow:hidden;
                            text-overflow:ellipsis;
                        }
                        .count {
                             font-size: 28px;

                            .num {
                                color: red;
                                margin-left: 8px;
                            }
                        }

                        .el-button {
                            height: 50px;
                            font-size: 30px;
                            padding: 0 8px;
                            border-radius: 24px;
                        }
                    }

                }
            }
        }
    }
}
</style>
